import { render } from "./CategoryGridPage.vue?vue&type=template&id=13d00f0a&scoped=true"
import script from "./CategoryGridPage.vue?vue&type=script&lang=js"
export * from "./CategoryGridPage.vue?vue&type=script&lang=js"

import "./CategoryGridPage.vue?vue&type=style&index=0&id=13d00f0a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d00f0a"]])

export default __exports__